import {Market} from 'utilities/use-shop-locales-and-markets';

export function validLocalesForMarket(market: Market, allMarkets: Market[]) {
  if (market?.webPresences.length) {
    return [
      ...new Set(
        market.webPresences.flatMap(({defaultLocale, alternateLocales}) => [
          defaultLocale,
          ...alternateLocales,
        ]),
      ),
    ];
  } else {
    // If a market has no web presence then it inherits its locales from the shops primary market
    const primaryMarketWebPresences = allMarkets.find(
      ({primary}) => primary,
    )?.webPresences;
    return primaryMarketWebPresences?.length
      ? [
          ...new Set(
            primaryMarketWebPresences.flatMap(
              ({defaultLocale, alternateLocales}) => [
                defaultLocale,
                ...alternateLocales,
              ],
            ),
          ),
        ]
      : [];
  }
}

export const marketHandleFromLocaleChange = (
  markets: Market[],
  locale: string,
  marketHandle?: string | null,
) => {
  const market = marketHandle
    ? markets.find(({handle}) => handle === marketHandle)
    : undefined;

  // If the current market does not include the new locale switch to translation
  // of the locale
  if (market && !validLocalesForMarket(market, markets).includes(locale)) {
    return {marketHandle: undefined};
  }

  return {marketHandle: market?.handle};
};
